import { Action } from 'redux';
import { CancellationAndNoShowsReport } from 'model/CancellationAndNoShowsReport';

export const CANCELLATION_NO_SHOWS_REPORT_GET_START = 'CANCELLATION_NO_SHOWS_REPORT_GET_START';
export const CANCELLATION_NO_SHOWS_REPORT_GET_SUCCESS = 'CANCELLATION_NO_SHOWS_REPORT_GET_SUCCESS';
export const CANCELLATION_NO_SHOWS_REPORT_GET_ERROR = 'CANCELLATION_NO_SHOWS_REPORT_GET_ERROR';

type GetStart = Action<typeof CANCELLATION_NO_SHOWS_REPORT_GET_START>;

interface GetSuccess extends Action<typeof CANCELLATION_NO_SHOWS_REPORT_GET_SUCCESS> {
    payload: {
        report: CancellationAndNoShowsReport;
    };
}

type GetError = Action<typeof CANCELLATION_NO_SHOWS_REPORT_GET_ERROR>;

export type CancellationAndNoShowsReportAction = GetStart | GetSuccess | GetError;
